import { CSSProgressiveHeading01 } from "@caisy/league";
import styled from "styled-components";

export const SUpgradeProjectWarningModalTitle = styled.h1`
  ${CSSProgressiveHeading01};
  color: var(--text-01);
  text-align: center;
`;
